<template>
  <div :id="page_slug">
    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item>Users</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <div class="actions-bar">
      <el-row>
        <el-col :span="6">
          <el-input placeholder="Search By First Name" v-on:keyup.native="whichSearchFunctionToUse" v-model="search_terms">
            <template slot="append"><el-button slot="append" icon="el-icon-search"></el-button></template>
          </el-input>
        </el-col>

        <el-col :span="17" :offset="1" class="text-right">
          <el-dropdown trigger="click" :hide-on-click="false">
            <el-tooltip class="item" effect="light" content="Show or hide columns" placement="top">
              <el-button>
                Columns <i class="el-icon-caret-bottom"></i>
              </el-button>
            </el-tooltip>
            
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(column, index) in columns" :key="index">
                <el-checkbox v-model="columns[index]">{{index | prettyIndexName}}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <router-link :to="{ name: 'UserAdd' }">
            <el-button :disabled="!hasRole('users.can_add')" type="default">Add User</el-button>
          </router-link>
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-table
        v-loading="loading"
        :data="users"
        border
        resizable="true"
        style="width: 100%">

        <el-table-column
          v-if="columns.id"
          width="115%"
          prop="id"
          label="ID">
        </el-table-column>

        <el-table-column
          v-if="columns.login"
          prop="login"
          label="Login">
        </el-table-column>

        <el-table-column
          v-if="columns.firstName"
          prop="firstName"
          label="First Name">
        </el-table-column>

        <el-table-column
          v-if="columns.lastName"
          prop="lastName"
          label="Last Name">
        </el-table-column>

        <el-table-column
          v-if="columns.email"
          prop="email"
          label="E-Mail">
        </el-table-column>

        <el-table-column
          v-if="columns.created_user_id"
          prop="created_user_id"
          label="Created User ID">
        </el-table-column>

        <el-table-column
          v-if="columns.updated_user_id"
          prop="updated_user_id"
          label="Updated User ID">
        </el-table-column>

        <el-table-column
          v-if="columns.user_access_id"
          prop="user_access_id"
          label="User Access ID">
        </el-table-column>

        <el-table-column
          v-if="columns.last_login"
          prop="last_login"
          label="Last Login">
        </el-table-column>

        <el-table-column
          v-if="columns.supplier_id"
          prop="supplier_id"
          label="Supplier ID">
        </el-table-column>

        <el-table-column
          v-if="columns.user_access"
          prop="user_access"
          label="User Access">
        </el-table-column>

        <el-table-column
          v-if="columns.user_roles"
          prop="user_roles"
          label="User Roles">
        </el-table-column>

        <el-table-column
          v-if="columns.user_profile"
          prop="user_profile"
          label="User Profile">
        </el-table-column>

        <el-table-column
          v-if="columns.created_at"
          align="center"
          width="115%"
          prop="created_at"
          label="Created Date">
          <template slot-scope="scope">
            {{scope.row.created_at | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <el-table-column
          v-if="columns.updated_at"
          align="center"
          width="115%"
          prop="updated_at"
          label="Updated Date">
          <template slot-scope="scope">
            {{scope.row.updated_at | moment(config.date_format_compact)}}
          </template>          
        </el-table-column>

        <el-table-column
          v-if="columns.type"
          width="115%"
          align="center"
          label="User Type">
          <template slot-scope="scope">
            <div v-if="scope.row.supplier_id != null">
              <el-tag>Supplier</el-tag>
            </div>
            <div v-else>
              <el-tag>Admin</el-tag>
            </div>
            <!-- <el-tag :type="userTypeLabel(scope.row.supplier_id)">Tag Two</el-tag> -->
          </template>
        </el-table-column>

        <el-table-column
          v-if="columns.status"
          width="115%"
          prop="status"
          align="center"
          label="Status">
          <template slot-scope="scope">
            <el-switch
              disabled
              :active-value="1"
              :inactive-value="0"
              v-model="scope.row.status">
            </el-switch>
          </template>
        </el-table-column>

       <el-table-column
          label="Actions"
          align="center"
          width="115%">
          <template slot-scope="scope">
            <router-link :to="{ name: 'UserEdit', params: { id: scope.row.id }}">
              <el-button 
                :disabled="!hasRole('users.can_edit')"
                icon="el-icon-edit"
                type="default" 
                size="small">
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-row :gutter="0">
      <el-col :span="24" :xs="24" :sm="24" class="pagination">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="pagination.current_page"
          :page-count="pagination.total_pages"
          :page-size="pagination.per_page"
          layout="total, prev, pager, next"
          :total="pagination.total">
        </el-pagination>
      </el-col>
    </el-row>

    <pre>{{$data}}</pre>
  </div>
</template>

<style>
</style>

<script>
  import Config from '@/store/Config.js';
  import Tables from '@/store/Tables.js';
  import store from '@/store/Store.js';
  
  export default {
    data: function() {
      return {
        page_alias: 'Users List',
        page_slug: 'user-list',

        permissions: store.permissions,
        config: Config.config,
        columns: Tables.users.columns,
        order_by: Tables.users.order_by,
        sort_by: Tables.users.sort_by,

        loading: true,
        search_terms: '',
        users: [],

        pagination: {
          total: 0,
          per_page: 0,
          current_page: 0,
          last_page: 0,
          next_page_url: '',
          prev_page_url: '',
          from: 0,
          to: 0,
        }
      };
    },

    mounted: function() {
      const me = this;
      me.getUsers();
    },

    methods: {
      hasRole: function(role_name) {
        const me = this;

        if(me.permissions.user_roles.length > 0) {
          /* returns undefined if doesn't find the role */
          var role = _.find(me.permissions.user_roles, function(o) { 
            return o.name == role_name; 
          });

          /* doesn't enter if when undefined */
          if(role) {
            return true
          }
        }
        
        return false;
      },

      whichSearchFunctionToUse: function() {
        const me = this;
        if(me.search_terms == '') {
          me.getUsers();
        } else me.search();
      },

      search: function(goToPage) {
        console.log('Search Users Function');
        const me = this;

        me.loading = true;

        me.$http.get(me.config.api + 'user-search', {params: {search_query: me.search_terms, page: goToPage}}).then(
        response => {
          console.log('Search Users Function - Success Getting Data')  

          me.users = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Search Users Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      getUsers: function(goToPage) {
        console.log('Get Users Function');
        const me = this;

        me.loading = true;
        
        me.$http.get(me.config.api + 'user', {params: {page: goToPage}}).then(
          response => {
          console.log('Get Users Function - Success Getting Data');

          me.users = response.body.data;
          me.handlePagination(response);

          me.loading = false;
        }, response => {
          console.log('Get Users Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });

          me.loading = false;
        });
      },

      handlePagination: function(response) {
        const me = this;

        me.pagination.total = response.body.total;
        me.pagination.per_page = response.body.per_page;
        me.pagination.current_page = response.body.current_page;
        me.pagination.last_page = response.body.last_page;
        me.pagination.next_page_url = response.body.next_page_url;
        me.pagination.prev_page_url = response.body.prev_page_url;
        me.pagination.from = response.body.from;
        me.pagination.to = response.body.to;
			},

      handleCurrentChange(val) {
        const me = this;

        if(me.search_terms == '') {
          me.getUsers(val);
        } else me.search(val);

        window.scrollTo(0,0);
      }
    },

    filters: {
      prettyIndexName(text) {
        var prettyName = text.replace(/_/g, ' ').toUpperCase();
        return prettyName
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/users/UserList.vue